'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _common = require('../common');

var _constants = require('../../constants');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ROUTING = _constants.AppConstants.ROUTING,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var formatPhoneNumber = _utils.FormattingUtils.formatPhoneNumber,
    getOrDefault = _utils.FormattingUtils.getOrDefault;
var ContactPopover = (_dec = (0, _mobxReact.inject)('Clients', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(ContactPopover, _Component);

  function ContactPopover(props) {
    _classCallCheck(this, ContactPopover);

    var _this = _possibleConstructorReturn(this, (ContactPopover.__proto__ || Object.getPrototypeOf(ContactPopover)).call(this, props));

    _initDefineProp(_this, 'isLoading', _descriptor, _this);

    _initDefineProp(_this, 'contact', _descriptor2, _this);

    _this.contact = props.contact;
    return _this;
  }

  _createClass(ContactPopover, [{
    key: 'setRefPopover',
    value: function setRefPopover(ref) {
      this.refPopover = ref;
    }
  }, {
    key: 'onClick',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, fetchContactId, Clients, SessionStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, fetchContactId = _props.fetchContactId, Clients = _props.Clients, SessionStore = _props.SessionStore;

                if (!(!this.contact && fetchContactId)) {
                  _context.next = 7;
                  break;
                }

                this.isLoading = true;
                _context.next = 5;
                return Clients.people.retrieve(fetchContactId);

              case 5:
                this.contact = _context.sent;

                this.isLoading = false;

              case 7:

                SessionStore.trackEvent('CONTACT_POPOVER_CLICK', { contact: this.contact, url: window.location.href });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onClick() {
        return _ref.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_OverlayTrigger2.default, _extends({}, this.props, { onClick: this.onClick, overlay: this.popoverComponent }));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'popoverComponent',
    get: function get() {
      var title = this.props.title,
          _ref2 = this.contact || {},
          additional_contact_info = _ref2.additional_contact_info,
          email = _ref2.email,
          id = _ref2.id,
          phone_number = _ref2.phone_number,
          _ref3 = additional_contact_info || {},
          cell_number = _ref3.cell_number,
          fax_number = _ref3.fax_number;


      return _react2.default.createElement(
        _Popover2.default,
        { id: 'popover-contact-' + id, className: 'popover-contact', title: title, ref: this.setRefPopover },
        _react2.default.createElement(
          'div',
          { className: 'content' },
          this.isLoading ? 'Loading contact...' : _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(_common.Icon, { type: 'envelope', title: 'Email address' }),
              ' ',
              getOrDefault(email)
            ),
            _react2.default.createElement(
              'div',
              { className: 'flex-two-cols' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_common.Icon, { type: 'phone', title: 'Phone number' }),
                ' ',
                getOrDefault(formatPhoneNumber(phone_number))
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_common.Icon, { type: 'mobile', title: 'Mobile number' }),
                ' ',
                getOrDefault(formatPhoneNumber(cell_number))
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_common.Icon, { type: 'fax', title: 'Fax number' }),
                ' ',
                getOrDefault(formatPhoneNumber(fax_number))
              )
            )
          )
        ),
        !this.isLoading && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            _reactRouterBootstrap.LinkContainer,
            { to: { pathname: ROUTING.peopleList + '/' + id, state: USER_FLOW.FROM_CASE_DETAIL_PAGE } },
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', className: 'pull-right' },
              'Details ',
              _react2.default.createElement(_common.Icon, { type: 'angle-double-right' })
            )
          )
        )
      );
    }
  }]);

  return ContactPopover;
}(_react.Component), _class3.defaultProps = {
  placement: 'bottom',
  trigger: 'click'
}, _class3.propTypes = {
  Clients: _propTypes2.default.object,
  contact: _propTypes2.default.object,
  fetchId: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  SessionStore: _propTypes2.default.object,
  title: _propTypes2.default.string
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'contact', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class) || _class) || _class);
var _default = ContactPopover;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/common-popovers/ContactPopover.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/common-popovers/ContactPopover.js');
  reactHotLoader.register(formatPhoneNumber, 'formatPhoneNumber', '/app/src/components/common-popovers/ContactPopover.js');
  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/common-popovers/ContactPopover.js');
  reactHotLoader.register(ContactPopover, 'ContactPopover', '/app/src/components/common-popovers/ContactPopover.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-popovers/ContactPopover.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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